<template>
  <v-container class="pa-0 ma-0 academics-page">
    <h1 class="show-title mb-10">{{ content.title }}</h1>

    <v-img
      src="@/assets/images/academics/sciencepreneur/sciencepreneur_course.png"
      height="180"
      contain
      class="mb-10"
    ></v-img>
    <div v-html="content.part1" class="academics-text"></div>
    <v-expansion-panels flat
      ><v-expansion-panel>
        <v-expansion-panel-header>
          <div v-html="content.exp1Header" class="academics-text"></div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="content.exp1Content" class="academics-text"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
export default {
  name: 'sciencepreneur',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.academics-page {
  table,
  th,
  td {
    width: 100%;
    border: 1px solid black;
    border-collapse: collapse;
    padding: 8px;
  }

  .img {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
